import React, { useEffect, useState } from "react";
import { TL } from "../i18n";
import client from "../lib/api";
import SeederHost, { slug, holdingValue } from "./SeederHost";
import { money } from "../lib/holdingsMath";

// Single category-level multi-seeder host (Land, Options, Trusts and Tangents, etc.)
export default function CategorySeeders({ category, items = [], reload }) {
  const [loaded, setLoaded] = useState([]);
  const optKey = `altseed:${category}:${category}`;
  const scoped = items.filter((h) => h.alt_block === category && h.alt_item === category);
  const rollValue = scoped.reduce((a, h) => a + holdingValue(h), 0);

  const load = () => client.get("/options/holdings").then((r) => {
    const v = (r.data || {})[optKey];
    setLoaded(Array.isArray(v) ? v.filter(Boolean) : []);
  }).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [category]);

  const save = async (arr) => {
    setLoaded(arr);
    await client.put(`/options/holdings/${optKey}`, { values: arr }).catch(() => {});
  };
  const onAdd = (s) => { if (!loaded.includes(s)) save([...loaded, s]); };
  const onRemove = (s) => save(loaded.filter((x) => x !== s));

  return (
    <div className="space-y-2" data-testid={`catseed-${slug(category)}`}>
      <div className="flex items-center gap-2 text-[11px] opacity-60">
        <span>{TL("Load one or more data-entry")} <b>{TL("seeders")}</b> for {category}; records stay scoped to {category}.</span>
        {scoped.length > 0 && <span className="ms-auto font-semibold text-[var(--primary)] opacity-100" data-testid={`catseed-roll-${slug(category)}`}>{scoped.length} rec · {money(rollValue)}</span>}
      </div>
      <SeederHost scopeCategory={category} block={category} item={category} items={items} reload={reload}
        loaded={loaded} onAdd={onAdd} onRemove={onRemove} tp={`cat-${slug(category)}`} />
    </div>
  );
}
